import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    triangle: {
        width: '0',
        height: '0',
        borderLeft: '100px solid transparent',
        borderRight: '100px solid transparent',
        borderTop: '40px solid #f00',
        marginTop: '30px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '30px',
    }
}));

// フロー三角
function FlowArrow(){
    const classes = useStyles();

    return(
        <Box className={classes.triangle}></Box>
    );
}

export default FlowArrow
